import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Stack, Box } from '@mui/material';

import { doc, onSnapshot } from 'firebase/firestore';
import { store } from '../../../config/firebase';
import PoweredBy from '../../ui/poweredBy';
import BSCircularProgress from '../../ui/progress/circularProgress';
import EmbeddedActiveGames from '../activeGames';
import EmbeddedAllGames from '../allGames';
import EmbeddedTabButtons from '../embeddedTabButtons';
import { getBracketsByEventId } from '../../../features/bracket/bracketSlice';
import Bracket from '../../bracket';
import { getGameType } from '../../../constants/gameConstants';
import SingleBracket from '../../ui/bracket';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

const EmbeddedBracketView = () => {
  const dispatch = useDispatch();
  const event = useSelector((state) => state.event.event);
  const loading = useSelector((state) => state.event.loading);
  const brackets = useSelector((state) => state.bracket.brackets);

  const loadingLeaderboard = useSelector((state) => state.leaderboard.loading);
  const [selectedTab, setSelectedTab] = React.useState(0);

  const [linkedEvents, setLinkedEvents] = useState([]);
  const showAllGamesTab = event?.specialty != null;

  const tabs = [{ label: 'Active Games', value: 0 }];
  if (showAllGamesTab) {
    tabs.push({ label: 'All Games', value: 1 });
  }
  if (brackets.length > 0) {
    tabs.push({ label: 'Bracket', value: showAllGamesTab ? 2 : 1 });
  }

  useEffect(() => {
    dispatch(getBracketsByEventId(event.id));
  }, [event.id, dispatch]);

  // const getLinkedEvents = async () => {
  //   const linkedEvents = event.linkedEvents;
  //   if (!linkedEvents || linkedEvents.length === 0) {
  //     setLinkedEvents([]);
  //     return;
  //   }

  //   const linkedEventsData = [];
  //   for (let i = 0; i < linkedEvents.length; i++) {
  //     const docRef = doc(store, 'events', linkedEvents[i]);
  //     onSnapshot(docRef, (doc) => {
  //       if (doc.exists()) {
  //         linkedEventsData.push({ id: doc.id, ...doc.data() });
  //       }
  //     });
  //   }
  //   setLinkedEvents(linkedEventsData);
  // };

  // useEffect(() => {
  //   if (event) {
  //     getLinkedEvents();
  //   }
  // }, [event]);

  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        m={2}>
        <Typography variant="h5">Scores</Typography>
      </Box>
      {loadingLeaderboard || loading ? (
        <BSCircularProgress caption={'Loading...'} size={30} />
      ) : (
        <Box sx={{ width: '100%' }}>
          {/* {linkedEvents && (
            <Box display={'flex'} justifyContent={'center'} gap={2} py={1}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => navigate(`/embed/event/${event.id}`)}>
                {getGameType(event.gameFormat.gameType)}
              </Button>
              {linkedEvents.map((linkedEvent) => (
                <Button
                  key={linkedEvent.id}
                  variant={'outlined'}
                  color="primary"
                  size="small"
                  onClick={() => navigate(`/embed/event/${linkedEvent.id}`)}>
                  {getGameType(linkedEvent.gameFormat.gameType)}
                </Button>
              ))}
            </Box>
          )} */}

          <EmbeddedTabButtons
            tabs={tabs}
            value={selectedTab}
            onChange={setSelectedTab}
            ariaLabel="Scores views"
          />

          <CustomTabPanel value={selectedTab} index={0}>
            <Box
              sx={{ width: '100%' }}
              display={'flex'}
              flexDirection={'row'}
              gap={3}
              justifyContent={'center'}
              flexWrap={'wrap'}
              py={2}>
              <Stack>
                <EmbeddedActiveGames event={event.id} />
              </Stack>
            </Box>
          </CustomTabPanel>
          {showAllGamesTab && (
            <CustomTabPanel value={selectedTab} index={1}>
              <Box
                sx={{ width: '100%' }}
                display={'flex'}
                flexDirection={'row'}
                gap={3}
                justifyContent={'center'}
                flexWrap={'wrap'}
                py={2}>
                <Stack>
                  <EmbeddedAllGames event={event.id} />
                </Stack>
              </Box>
            </CustomTabPanel>
          )}
          {brackets.length > 0 && (
            <CustomTabPanel value={selectedTab} index={showAllGamesTab ? 2 : 1}>
              <Box
                sx={{ width: '100%' }}
                display={'flex'}
                flexDirection={'row'}
                gap={3}
                justifyContent={'center'}
                flexWrap={'wrap'}
                py={2}>
                <SingleBracket bracket={brackets[0]} event={event} />
              </Box>
            </CustomTabPanel>
          )}
        </Box>
      )}
      <PoweredBy />
    </Box>
  );
};

export default EmbeddedBracketView;
